import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		// Get the product title from the data attribute
		let productTitle = this.el.dataset.product;

		// Find the form container
		let jsProduct = this.el.querySelector(".js-products");

		if (!jsProduct) {
			console.error("Could not find .js-products element");
			return;
		}

		// Find the hidden input
		let hiddenInput = jsProduct.querySelector("input");

		if (!hiddenInput) {
			console.error("Could not find input element inside .js-products");
			return;
		}

		// Set the hidden input value with the product title
		if (productTitle) {
			hiddenInput.value = productTitle;
		} else {
			// Default value if product title is not available
			hiddenInput.value = "Default Product";
		}
	}
}
